
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBfGMBbZmtemVH9ndmStbQm7JyIKBSKbkk",
  authDomain: "gamegraphics-34504.firebaseapp.com",
  projectId: "gamegraphics-34504",
  storageBucket: "gamegraphics-34504.appspot.com",
  messagingSenderId: "629416078840",
  appId: "1:629416078840:web:475daee628b2988709fa0d",
  measurementId: "G-2ZGBF1RFQN",
  databaseURL : "https://gamegraphics-34504-default-rtdb.europe-west1.firebasedatabase.app",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const database = getDatabase(app);